import moment, { MomentInput } from 'moment';

export default function isNowLater(date: MomentInput): boolean {
  const now = moment().valueOf();
  const compareDate = moment(date).valueOf();

  return now > compareDate;
}
